import React from 'react';
import './index.css'
import {Link} from 'react-router-dom'
import arrow from './../../images/arrow_more_left.png'
export default class Layout extends React.Component {
    render() {
        return (
            <div className="layout">
                <div>
                    <span>{this.props.title}</span>
                    {this.props.more &&
                        <div>
                            <img src={arrow} alt=""></img> 
                            {this.props.moreUrl &&
                                <span><Link to={this.props.moreUrl}>{this.props.moreTitle ? this.props.moreTitle : '更多'}</Link></span>
                            }  
                            {!this.props.moreUrl &&
                                <span>{this.props.moreTitle ? this.props.moreTitle : '更多'}</span>
                            } 
                            
                        </div>
                    }
                </div>
                {this.props.children}
            </div>
        );
    }
}